<!-- @format -->

<ng-container *transloco="let t">
  @if (courseUnitAttainment) {
    <div class="course-unit-attainment-notification">
      <div class="sis-px-xxs">
        <span><sis-icon icon="info-circle-fill"></sis-icon> {{ t("PLAN.COURSE_UNIT_ATTAINED") }}</span>
        <sis-button (clicked)="openAttainmentDetailsModal()" [naked]="true" [size]="'sm'">{{
          t("PLAN.SHOW_ATTAINMENT_DETAILS")
        }}</sis-button>
      </div>
    </div>
  }
</ng-container>
